import { useState } from 'react'
import styled from 'styled-components'
import { Select } from 'sutra/components/Select/Select'

import { CreateAccountModalContainer } from 'features/account-create/Container'
import { useAccounts } from 'features/accounts/hooks/use-accounts'
import { useAccountsService } from 'features/accounts/service'

const CREATE_ACCOUNT_VALUE = '__create_account__'

type Props = {
  value: string | null
  onChange: (uuid: string | null) => void
}

export const AccountSelectContainer = ({
  value,
  onChange,
}: Props): JSX.Element => {
  const service = useAccountsService()
  const { accounts, isLoading } = useAccounts(service)
  const [isCreateModalOpen, setCreateModalOpen] = useState(false)

  return (
    <>
      <AccountSelect
        searchable
        allowClear
        placeholder="Select an account (optional)"
        loading={isLoading}
        filterOption={(input, option) =>
          option.value === CREATE_ACCOUNT_VALUE ||
          String(option.label).toLowerCase().includes(input.toLowerCase())
        }
        value={value ?? undefined}
        onChange={(uuid) => {
          if (uuid === CREATE_ACCOUNT_VALUE) {
            setCreateModalOpen(true)
            return
          }
          onChange((uuid as string | undefined) ?? null)
        }}
        options={[
          ...accounts.map((account) => ({
            label: account.name,
            value: account.uuid,
          })),
          // An action row, not an account: picking it opens the create modal
          // and never becomes the field's value.
          { label: 'Create new account', value: CREATE_ACCOUNT_VALUE },
        ]}
      />
      <CreateAccountModalContainer
        open={isCreateModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onCreated={(account) => onChange(account.uuid)}
      />
    </>
  )
}

const AccountSelect = styled(Select)`
  width: 100%;
`
